import type { DoctoraliaAuthentication } from "@/types/DoctoraliaAuthentication";

type UserIdentity = DoctoraliaAuthentication["userIdentity"];

// The header MFE expects isAdmin as a real boolean. Sessions stored before the
// connector returned it have no value, so they fall back to false.
export function toHeaderUserIdentity(
  userIdentity?: UserIdentity
): UserIdentity | undefined {
  if (!userIdentity) {
    return undefined;
  }

  return { ...userIdentity, isAdmin: userIdentity.isAdmin === true };
}
